<template>
  <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27 16.5V4.245C27 1.905 25.095 0 22.755 0C21.63 0 20.55 0.45 19.755 1.245L17.88 3.12C17.64 3.045 17.385 3 17.115 3C16.515 3 15.96 3.18 15.495 3.48L19.635 7.62C19.935 7.155 20.115 6.6 20.115 6C20.115 5.73 20.07 5.49 20.01 5.235L21.885 3.36C22.11 3.135 22.425 3 22.755 3C23.445 3 24 3.555 24 4.245V16.5H13.725C13.275 16.185 12.87 15.825 12.495 15.42L10.395 13.095C10.11 12.78 9.75 12.525 9.36 12.345C8.895 12.12 8.385 12 7.86 12C6 12.015 4.5 13.515 4.5 15.375V16.5H0V25.5C0 27.15 1.35 28.5 3 28.5C3 29.325 3.675 30 4.5 30H25.5C26.325 30 27 29.325 27 28.5C28.65 28.5 30 27.15 30 25.5V16.5H27Z"
      fill="currentColor"
    />
  </svg>
</template>
